export const AboutScreen = () => `
    <div id="about-screen" class="screen">
        <script>
            // Redirect to single page home section
            window.location.hash = "#about-section";
            document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' });
        </script>
    </div>
`;
